<template>
  <div class="saved-assessments" v-show="isActive">
    <div v-if="savedAssessmentCount == 0">
      <div class="no-item">
        <div class="text-center">
        <img class="pb-3" src="/assets/images/no-assessment.svg" alt="No assessments" />
        <p class="no-assessment">There are no assessments</p>
      </div>
      </div>
    </div>
    <div v-else>
      <div class="count">
        {{ savedAssessmentCount }} saved assessment{{
          savedAssessmentCount === 1 ? "" : "s"
        }}
      </div>
      <hr class="solid" />
      <div id="accordion">
        <div
          
          v-for="(assessment, i) in satContent.Tools"
          :key="assessment.Id"
          
        >
          <template v-if="assessment.SavedAssessmentDateCreated">
            <div class="card mb-3">
            <!-- Header -->
            <button
              :class="i===0? 'card-header':'card-header collapsed'"
              :aria-controls="`collapse-${i}`"
              data-toggle="collapse"
              data-parent="#accordion"
              :href="`#collapse-${i}`"
              :aria-expanded="i ===0 ? 'true' :'false'"
            >
              <div class="p-0 mb-0 w-100 btn">
                <div class="item-group-1">
                  <div class="assessment-name">{{ assessment.Name }}&nbsp;<span class="standard d-none d-md-inline-block">{{ assessment.Standards.length }} Standard{{
                      assessment.Standards.length === 1 ? "" : "s"
                    }}</span></div >
                  <!-- <div class="assessment-name mr-2">{{ assessment.Name }}</div>  -->
                  <div class="standard d-md-none">
                    {{ assessment.Standards.length }} Standard{{
                      assessment.Standards.length === 1 ? "" : "s"
                    }}
                  </div>
                   <span class="date d-md-none"
                    >Last saved {{ dateUpdated(assessment) }}</span
                  >
                </div>
                <div class="item-group-2">
                  <span class="date d-none d-md-block"
                    >Last saved {{ dateUpdated(assessment) }}</span
                  >
                </div>
              </div>
            </button>
            <!-- Header End -->
            <!-- Body -->
            <div
              :id="`collapse-${i}`"
              :class="i ===0 ? 'collapse show': 'collapse'"
            >
              <div class="card-body">
                <div
                  v-for="standard in assessment.Standards"
                  :key="standard.Id"
                >
                  <OverviewSavedAssessmentsStandard
                    :standard="standard"
                    :satId="assessment.Id"
                  />
                </div>
 <!-- Button -->
               <div
                class="form-row card-buttons flex-column-reverse flex-md-row"
              >
                <div class="col-12 col-md-6">
                  <a
                    class="view"
                    v-if="assessment.FeedbackLinkUrl"
                    :href="assessment.FeedbackLinkUrl"
                    :target="assessment.FeedbackLinkTarget"
                    >{{ assessment.FeedbackLinkText }}</a
                  >
                </div>
                <div class="col-12 col-md-6">
                  <button 
                    @click="routeToActionPlan(assessment.Id)"
                      @keydown="routeToActionPlan(assessment.Id)"
                    class="cta-white-219"
                  >
                    View action plan<span class="angle-right-white"></span>
                  </button>
                </div>
              </div> 
              <!-- Button End -->

              </div>
              <!-- <div class="col-6 col-md-2 date">ccc</div>
            <div class="col-6 col-md-2">
              <a class="view" @click="routeToReview(assessment.Id, standard.Id)"
                >Review <span class="angle-right-green"></span>
              </a>
            </div> -->
              <!-- </div> -->
             
            </div>
            <!-- Body End -->
            </div>
          </template>
        </div>
      </div>
      <!-- Accordion End -->
    </div>
    <div class="space"></div>
  </div>
</template>

<script>
import { privateRouter } from "../router";
import OverviewSavedAssessmentsStandard from "@/components/overview-saved-assessments-standard";
import moment from "moment";

export default {
  name: "OverviewSavedAssessments",
  components: {
    OverviewSavedAssessmentsStandard
  },
  data() {
    return {
      isActive: true
      //assessmentCount: this.satContent.Tools.length
    };
  },
  created() {},
  props: {
    satContent: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    routeToStandard(satId, standardId) {
      privateRouter.push({
        name: "AssessmentStandard",
        query: {
          satId: satId,
          standardId: standardId
        }
      });
    },
    routeToActionPlan(satId) {
      privateRouter.push({
        name: "ActionPlan",
        query: {
          satId: satId
        }
      });
    },
    dateUpdated(currentAssessment) {
      // all responses are updated when saved, so just get the UpdatedDate of the first response (if it has ever been saved)
      return currentAssessment.Standards[0].Sections[0].Questions[0]
        .SAT_SavedResponses.Id
        ? // we have a saved response
          moment(
            currentAssessment.Standards[0].Sections[0].Questions[0]
              .SAT_SavedResponses.DateUpdated
          ).format("LL")
        : // response Id is null so assessment has never been saved
          "Assessment not saved";
    }
  },
  computed: {
    savedAssessmentCount() {
      let savedAssessments = 0;
      this.satContent.Tools.forEach(tool => {
        if (tool.SavedAssessmentDateCreated) {
          // assessments that have never been saved will have null SavedAssessmentDateCreated
          savedAssessments++;
        }
      });
      return savedAssessments;
    }
  }
};
</script>

<style lang="sass" scoped></style>
